import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const HeartIconFill: React.FC<OneColorIconProps> = ({ size = 16, color = 'black', className }) => {
  const c = getHexColor(color)

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.2001 28.6204L11.9001 26.4818C9.54453 24.2866 7.41697 22.1082 5.51741 19.9465C3.61697 17.7857 2.66675 15.404 2.66675 12.8015C2.66675 10.6742 3.36675 8.89767 4.76675 7.47193C6.16675 6.04618 7.91119 5.33331 10.0001 5.33331C11.1779 5.33331 12.289 5.58768 13.3334 6.09642C14.3779 6.60607 15.2667 7.3022 16.0001 8.1848C16.7334 7.3022 17.6223 6.60607 18.6667 6.09642C19.7112 5.58768 20.8223 5.33331 22.0001 5.33331C24.089 5.33331 25.8334 6.04618 27.2334 7.47193C28.6334 8.89767 29.3334 10.6742 29.3334 12.8015C29.3334 15.404 28.389 17.7916 26.5001 19.9641C24.6112 22.1367 22.4667 24.3206 20.0667 26.5158L17.8001 28.6204C17.289 29.0957 16.689 29.3333 16.0001 29.3333C15.3112 29.3333 14.7112 29.0957 14.2001 28.6204Z"
        fill={c}
      />
    </svg>
  )
}
